import React from 'react'
import clsx from 'clsx'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import IconButton from '@material-ui/core/IconButton'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Collapse from '@material-ui/core/Collapse'
import PropTypes from 'prop-types'
// eslint-disable-next-line no-unused-vars
import { Route, Link, withRouter } from 'react-router-dom'
import { routeConfig } from './route'
import hoc from '@hoc'
import Tooltip from '@material-ui/core/Tooltip'
import * as utils from '@utils'
import { API } from '@const'

class Sidebar extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'Sidebar')
        }
    }

    state = {
        collapseSwitchs: {
            eventManage: false,
            gameManage: false,
            membershipManage: false,
            operationManage: false,
            marketingManage: false,
            cmsSystemManage: false,
            internalControlManage: false,
            zioFunction: false,
        },
        event_management: '',
        event_prize: ''
    }

    componentDidMount() {
        Object.keys(this.state.collapseSwitchs).forEach((routeGroupID) => {
            routeConfig[routeGroupID].childNode.forEach((route) => {
                if (this.props.location.pathname === route.path) {
                    this.setState({
                        collapseSwitchs: {
                            ...this.state.collapseSwitchs,
                            [routeGroupID]: true,
                        },
                    })
                }
            })
        })
        this.queryEventUrl()
    }

    queryEventUrl() {
        utils.apiRequest(
            'get',
            API.EVENT_SYSTEM,
            {},
            (data) => {
                const event_management = data.find((item) => item.route_code === 'activity')?.path || ''
                const event_prize = data.find((item) => item.route_code === 'payout')?.path || ''
                this.setState({
                    event_management,
                    event_prize
                })
            },
            (_err) => {
                console.log(_err)
            },
            true
        )
    }

    render() {
        const { classes } = this.props

        return (
            <Drawer
                variant="permanent"
                className={clsx(classes.drawer, {
                    [classes.drawerOpen]: this.props.sidebarSwitch,
                    [classes.drawerClose]: !this.props.sidebarSwitch,
                })}
                classes={{
                    paper: clsx({
                        [classes.drawerOpen]: this.props.sidebarSwitch,
                        [classes.drawerClose]: !this.props.sidebarSwitch,
                    }),
                }}
                open={this.props.sidebarSwitch}>
                <div className={classes.toolbar}>
                    <IconButton onClick={() => this.props.switchSidebar()}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <Divider />
                <List component="div" disablePadding>
                    <Route path={routeConfig.home.childNode[0].path}>
                        <Tooltip
                            placement="right"
                            title={!this.props.sidebarSwitch ? utils.t('Title', routeConfig.home.childNode[0].componentName) : ''}>
                            <Link to={routeConfig.home.childNode[0].path} className={classes.linkItemStyle}>
                                <ListItem button>
                                    <ListItemIcon>{routeConfig.home.childNode[0].icon}</ListItemIcon>
                                    <ListItemText primary={utils.t('Title', routeConfig.home.childNode[0].componentName)} />
                                </ListItem>
                            </Link>
                        </Tooltip>
                    </Route>
                </List>
                <List disablePadding>
                    {Object.keys(routeConfig)
                        .filter((routeGroupID) => {
                            if (routeGroupID === 'home') {
                                return false
                            }

                            for (const idx in routeConfig[routeGroupID].childNode) {
                                if (utils.checkValid(routeConfig[routeGroupID].childNode[idx].id + '.view')) {
                                    return true
                                }
                            }

                            return false
                        })
                        .map((routeGroupID, _idx) => {
                            return (
                                <div key={routeGroupID}>
                                    <Tooltip placement="right" title={!this.props.sidebarSwitch ? this.t(routeGroupID) : ''}>
                                        <ListItem
                                            button
                                            onClick={() => {
                                                this.setState({
                                                    collapseSwitchs: {
                                                        ...this.state.collapseSwitchs,
                                                        [routeGroupID]: !this.state.collapseSwitchs[routeGroupID],
                                                    },
                                                })
                                            }}>
                                            <ListItemIcon
                                                className={clsx({
                                                    [classes.collapsed]: !this.props.sidebarSwitch,
                                                })}>
                                                {routeConfig[routeGroupID].icon}
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={this.t(routeGroupID)}
                                                className={clsx({
                                                    [classes.hidden]: !this.props.sidebarSwitch,
                                                })}
                                            />
                                            {this.state.collapseSwitchs[routeGroupID] ? <ExpandLess /> : <ExpandMore />}
                                        </ListItem>
                                    </Tooltip>
                                    <Collapse in={this.state.collapseSwitchs[routeGroupID]} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            {routeConfig[routeGroupID].childNode.map((route, routeIdx) => {
                                                if (utils.checkValid(route.id + '.view')) {
                                                    if (['event_management', 'event_prize'].includes(route.id)) {
                                                        return (
                                                            <div
                                                                key={routeIdx}
                                                                onClick={() => {
                                                                    window.open(this.state[route.id], route.id, 'toolbar=no, location=yes, directories=no, status=no, menubar=yes, resizable=yes, copyhistory=yes, width=1500, height=800');
                                                                }}
                                                            >
                                                                <Tooltip
                                                                    placement="right"
                                                                    title={!this.props.sidebarSwitch ? utils.t('Title', route.componentName) : ''}
                                                                    key={route.id}
                                                                >
                                                                    <div className={classes.linkItemStyle}>
                                                                        <ListItem
                                                                            button
                                                                            className={
                                                                                this.props.location.pathname === route.path
                                                                                    ? classes.listItemSelected
                                                                                    : classes.nested
                                                                            }>
                                                                            <ListItemIcon>{route.icon}</ListItemIcon>
                                                                            <ListItemText primary={utils.t('Title', route.componentName)} />
                                                                        </ListItem>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (
                                                            <Route path={route.path} key={routeIdx}>
                                                                <Tooltip
                                                                    placement="right"
                                                                    title={!this.props.sidebarSwitch ? utils.t('Title', route.componentName) : ''}
                                                                    key={route.id}
                                                                >
                                                                    <Link to={route.path} className={classes.linkItemStyle}>
                                                                        <ListItem
                                                                            button
                                                                            className={
                                                                                this.props.location.pathname === route.path
                                                                                    ? classes.listItemSelected
                                                                                    : classes.nested
                                                                            }>
                                                                            <ListItemIcon>{route.icon}</ListItemIcon>
                                                                            <ListItemText primary={utils.t('Title', route.componentName)} />
                                                                        </ListItem>
                                                                    </Link>
                                                                </Tooltip>
                                                            </Route>
                                                        )
                                                    }
                                                }

                                                return null
                                            })}
                                        </List>
                                    </Collapse>
                                </div>
                            )
                        })}
                </List>
            </Drawer>
        )
    }
}

Sidebar.propTypes = {
    classes: PropTypes.objectOf(PropTypes.string),
    switchSidebar: PropTypes.func,
    sidebarSwitch: PropTypes.bool,
    location: PropTypes.object,
}

const styles = (theme) => {
    const drawerWidth = 300

    return {
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
            whiteSpace: 'nowrap',
        },
        drawerOpen: {
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        drawerClose: {
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
            width: theme.spacing(7) + 1,
            [theme.breakpoints.up('sm')]: {
                width: theme.spacing(9) + 1,
            },
        },
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: '0 8px',
            ...theme.mixins.toolbar,
        },
        nested: {
            paddingLeft: theme.spacing(4),
        },
        listItemSelected: {
            paddingLeft: theme.spacing(4),
            backgroundColor: '#ccc',
        },
        hidden: {
            width: '0px',
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowX: 'hidden',
        },
        collapsed: {
            marginRight: '-30px',
            transition: theme.transitions.create('margin-right', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
		linkItemStyle: {
			display: 'block',
            color: '#000000',
		}
    }
}

export default withRouter(hoc(styles)(Sidebar))
